import { AxiosRequestConfig } from 'axios';
import { get, omit, pickBy } from 'lodash';
import { axiosService, TAvailability } from 'ui-model';
import { createKeys, InfiniteQueryOptions, useCreateInfiniteQuery } from 'ui-model/dist/CRUD';

const keys = createKeys('availabilities');

type TData = {
  response: TAvailability[];
  appointmentTypes: string[];
  facilities: string[];
  providers: string[];
  page: number;
  size: number;
};

// TODO: Move to `ui-model` once it's validated by QA in prod
const useAvailabilitySchedulerPagination = (
  initialParams?: AxiosRequestConfig['params'],
  options?: InfiniteQueryOptions<TData>,
) =>
  useCreateInfiniteQuery(
    keys.many(initialParams),
    async (params) => {
      const { data } = await axiosService.get('/v2/availabilities/scheduler', {
        params: get(params, 'zipcode', null) ? params : omit(params, 'zipcodeMaxDistance'),
      });
      return data as TData;
    },
    {
      limit: 100,
      sort: 'date',
      sortBy: 'asc',
      status: 'available',
      populate: true,
      includeNullApptTypes: true,
      ...pickBy(initialParams, (param) => param),
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage.response.length < 100) return undefined;
        return allPages.length + 1;
      },
      // Avoid calls missing the date range param
      enabled: !!initialParams?.date,
      // @ts-ignore TODO: Expose option from `ui-model#InfiniteQueryOptions` type
      refetchOnWindowFocus: false,
      ...options,
    },
  );

export default useAvailabilitySchedulerPagination;
